<script setup>
// BonBoZ: avatar trang thay cho icon kenh. Icon kenh giong het nhau giua cac
// page Facebook — nhan vien phai doc ten moi biet trang nao; avatar (hoac chu
// cai mau khi trang chua co anh) nhin phat la nhan ra.
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
// BonBoZ: 10+ page dung chung bo nhan dien nen avatar khong du phan biet —
// them VIEN mau cua trang (Cai dat > Giao dien). Vien ve bang box-shadow nen
// khong an them mot pixel be ngang nao cua cot danh sach hoi thoai; cham mau
// thi an. Chua dat mau = khong vien.
import { computed } from 'vue';
import { loadPageConfigs, pageColorOf } from 'dashboard/helper/pageConfig';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

// Nap mot lan cho ca app, moi lan goi sau dung chung promise cu.
loadPageConfigs();
const vienMau = computed(() => {
  const hex = pageColorOf(props.inbox?.id);
  return hex ? { boxShadow: `0 0 0 2px ${hex}` } : {};
});
</script>

<template>
  <div :title="inbox.name" class="flex items-center gap-1 min-w-0">
    <Avatar
      :src="inbox.avatar_url"
      :name="inbox.name || '?'"
      :size="16"
      rounded-full
      class="flex-shrink-0 rounded-full"
      :style="vienMau"
    />
    <span class="truncate text-label-small text-n-slate-11">
      {{ inbox.name }}
    </span>
  </div>
</template>
